// extracted by mini-css-extract-plugin
export default {"container":"container--O7VEfvFr","spacer":"spacer--w59KWYiM"};